import { FaLock } from "react-icons/fa";

const PremiumContentModal = ({
    isOpen,
    onClose,
    onSend,
    price,
    mediaCount,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
            <div className="relative w-[360px] rounded-2xl border border-white/10 bg-black px-6 py-8 text-center shadow-xl">

                {/* PREMIUM BADGE */}
                <div className="mx-auto mb-6 inline-flex items-center gap-2 rounded-full bg-red-500 px-4 py-2 text-sm font-semibold text-black">
                    <FaLock className="text-sm" />
                    PREMIUM CONTENT
                </div>

                {/* MEDIA PREVIEW */}
                <div className="relative mx-auto mb-4 h-[160px] w-[160px] rounded-xl overflow-hidden border border-white/20">

                    <img
                        src="/images/sample.jpg"
                        alt="premium"
                        className="absolute inset-0 h-full w-full object-cover filter blur-xl scale-110"
                    />

                    <div className="absolute inset-0 bg-black/20" />

                    <div className="absolute inset-0 flex items-center justify-center">
                        <FaLock className="text-3xl text-red-500" />
                    </div>
                </div>


                {/* INFO TEXT */}
                <div className="mb-2 text-lg font-semibold text-white">
                    {mediaCount} Photo
                </div>

                <p className="mb-6 text-sm text-gray-300">
                    When you send the gift, the Premium content will be unlocked.
                </p>

                {/* PRICE */}
                <div className="mb-6 flex items-center justify-center gap-2 text-white">
                    <img
                        src="./images/goldcoin.png"
                        alt="coin"
                        className="w-4 h-4 rounded-full object-cover"
                    />
                    <span className="text-white font-semibold">{price}</span>
                </div>

                {/* ACTION BUTTON */}
                <button
                    onClick={onSend}
                    className="mb-3 w-full rounded-full bg-red-500 py-3 font-semibold text-black transition"
                >
                    Send
                </button>

                {/* CANCEL */}
                <button
                    onClick={onClose}
                    className="w-full text-sm text-gray-400 hover:text-white"
                >
                    Cancel
                </button>
            </div>
        </div>
    );
};

export default PremiumContentModal;